import type {GlobalStore} from '@empjs/cli'
import {EmpShare} from './share'
import type {EMPPluginShareType} from './types'
export type {EMPPluginShareType}
//
export * from 'src/framework/react/config'
export * from 'src/framework/vue/config'
export * from './types'
//
export const pluginRspackEmpShare = (o: EMPPluginShareType = {}) => {
  return {
    name: '@empjs/share',
    async rsConfig(store: GlobalStore) {
      //
      if (o.manifest === true) {
        o.manifest = {
          fileName: 'emp.json',
        }
      } else if (typeof o.manifest === 'object') {
        o.manifest = store.deepAssign({fileName: 'emp.json'}, o.manifest)
      } else {
        // 默认情况下，如果 exposes 为空则不生成 manifest 避免冲突
        const hasExposes = o.exposes && Object.keys(o.exposes).length > 0
        if (hasExposes) {
          o.manifest = {
            fileName: 'emp.json',
          }
        } else {
          o.manifest = false
        }
      }
      const empShare = new EmpShare(o, store)
      empShare.setup()
    },
  }
}
export default pluginRspackEmpShare
